import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ContactGrouopService {

  constructor(private api: ApiService) { }

  createContact_group(data:any): Observable<any> {
    return this.api.post(environment.createContactGroup,data);
  }

  updateContact_group(data:any): Observable<any> {
    return this.api.post(environment.updateContactGroup,data);
  }

  getLeadsRocord(data:any): Observable<any> {
    return this.api.post(environment.getLeadsRocord,data);
  }

  getAllContactGroups(data:any): Observable<any> {
    return this.api.post(environment.getAllContactGroups,data);
  }

  getAllTemplate(data:any): Observable<any> {
    return this.api.post(environment.getAllWhatsappTemplates,data);
  }

  getAppId(data:any): Observable<any> {
    return this.api.post(environment.getAppId,data);
  }

  createTemplate(data:any): Observable<any> {
    return this.api.post(environment.createWhatsappTemplate,data);
  }


  getAllLanguages(): Observable<any> {
    return this.api.post(environment.getAllLanguages,{});
  }

  updateTemplate(data:any): Observable<any> {
    return this.api.post(environment.updateWhatsappTemplate,data);
  }

  deleteTemplate(data:any): Observable<any> {
    return this.api.post(environment.deleteWhatsappTemplate,data);
  }


  getAllLeads(data:any): Observable<any> {
    return this.api.post(environment.getAllLeads,data);
  }
  
  getAllContacts(data:any): Observable<any> {
    return this.api.post(environment.getAllContactWithCount,data);
  }

  createContactGroupList(data:any): Observable<any> {
    return this.api.post(environment.createContactGroupList,data);
  }

  getAllContactGroupList(data:any): Observable<any> {
    return this.api.post(environment.getAllContactGroupList,data);
  }

  deleteGroupListContact(data:any): Observable<any> {
    return this.api.post(environment.deleteContactGroupList,data);
  } 
  addGroupListContact(data:any): Observable<any> {
    return this.api.post(environment.addContactToGroupList,data);
  }
  updateContactGroupList(data:any): Observable<any> {
    return this.api.post(environment.updateContactGroupList,data);
  }

  getLeadAndContactId(data:any): Observable<any> {
    return this.api.post(environment.getLeadAndContactId,data);
  }

  deleteContactGroup(data:any): Observable<any> {
    return this.api.post(environment.deleteContactGroup,data);
  }
}


